export default {
    soccer: require('./assets/soccer.svg'),
    zombie: require('./assets/zombie.svg'),
    train: require('./assets/train.gif'),
    YLDLogo: require('./assets/logo.gif'),
    portugal: require('./assets/portugal.png'),
    mindblown: require('./assets/mindblown.gif'),
    homer: require('./assets/homer.gif'),
    anger: require('./assets/anger.gif'),
    fight: require('./assets/fight.gif'),
    greed: require('./assets/greed.gif'),
    lust: require('./assets/lust.gif'),
    badum: require('./assets/badum.gif'),
    lazy: require('./assets/lazy.gif'),
    envy: require('./assets/envy.gif'),
    pride: require('./assets/pride.jpg'),
    paris: require('./assets/paris.jpg')
}



// WEBPACK FOOTER //
// ./src/images.js